import React from 'react';
import './Loader.css';

interface LoaderProps {
  size?: 'small' | 'medium' | 'large';
  text?: string;
  fullscreen?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ 
  size = 'medium', 
  text = 'Loading...', 
  fullscreen = false 
}) => {
  return (
    <div className={`loader-container ${fullscreen ? 'loader-fullscreen' : ''}`}>
      <div className="loader-wrapper">
        {/* Main Loader */}
        <div className={`epic-loader ${size}`}>
          {/* Outer Ring */}
          <div className="loader-ring outer-ring">
            <div className="ring-segment"></div>
            <div className="ring-segment"></div>
            <div className="ring-segment"></div>
            <div className="ring-segment"></div>
          </div>

          {/* Middle Ring */}
          <div className="loader-ring middle-ring">
            <div className="ring-segment"></div>
            <div className="ring-segment"></div>
            <div className="ring-segment"></div>
          </div>

          {/* Inner Circle */}
          <div className="loader-core">
            <div className="core-pulse"></div>
            <div className="core-glow"></div>
          </div>

          {/* Orbiting Particles */}
          <div className="particle-orbit">
            <span className="particle particle-1"></span>
            <span className="particle particle-2"></span>
            <span className="particle particle-3"></span>
            <span className="particle particle-4"></span>
          </div>
        </div>

        {/* Loading Text */}
        {text && (
          <div className="loader-text">
            <span className="text-content">{text}</span>
            <span className="loading-dots">
              <span className="dot"></span>
              <span className="dot"></span>
              <span className="dot"></span>
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Loader;

